import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function selectYourXDropdownsReducer(state = initialState.selectYourXDropdowns, action) {
    // determine length of current state object
    let count = Object.keys(state).length;
    switch (action.type) {
        case types.SELECT_YOUR_X_DROPDOWN_TOGGLE:
            // determine length of current state object
            let currentIndexStatus = state[action.dropdownIndex].isSelectionOpen;

            // make a copy of current state to enforce immutable rules
            let newState = Object.assign({}, state);
            
            // reset all dropdowns to closed to control ui
            for (let i = 0; i < count; i++) {
                newState[i].isSelectionOpen = false;
            }

            // set active index to open
            newState[action.dropdownIndex].isSelectionOpen = !currentIndexStatus;
            
            return newState;
        case types.RESET_FORM_TO_DEFAULT:
            // make a copy of current state to enforce immutable rules
            let resetState = Object.assign({}, state);

            // reset all dropdowns to closed to control ui
            for (let i = 0; i < count; i++) {
                resetState[i].isSelectionOpen = false;
            }
            return resetState;
        default:
            return state;
    }
}